.uic-thumbnail-item {
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    outline: 0;
    outline-offset: -2px;
    border: 1px solid var(--uic-color-grey2);
    background: var(--uic-color-white);
    margin: 8px;
    cursor: pointer;
    user-select: none;
    width: var(--uic-thumbnail-item-width, 64px);
    height: var(--uic-thumbnail-item-height, 48px);
    position: relative;

    @include focus-visible-outline() {
        outline: 2px solid var(--uic-color-blue2);
    }

    &:hover,
    &:active {
        border: 1px solid var(--uic-color-blue2);

        .uic-thumbnail-item__icon,
        uic-icon {
            color: var(--uic-color-blue3);
        }
    }

    &:active {
        background: var(--uic-color-blue2a10);

        > img,
        > svg {
            opacity: 0.5;
        }
    }

    > img,
    > svg {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
    }

    uic-icon {
        color: var(--uic-color-grey3);
    }

    // use icon-bg as fallback to ensure correct white margin
    // with respect to the rest of the thumbnail item
    &__icon-bg {
        background: var(--uic-color-white);
        width: 24px;
        height: 22px;
    }

    &__icon,
    &__icon-bg {
        position: absolute;
        top: -10px;
        left: -8px;
    }

    &--placeholder uic-icon {
        color: var(--uic-color-grey6);
    }

    &.uic-thumbnail-item--selected {
        border: 1px solid var(--uic-color-blue2);
        box-shadow: 0 2px 8px 0 var(--uic-color-blue0a40);
        background: var(--uic-color-blue0a40);

        uic-icon {
            color: var(--uic-color-blue4);
        }
    }
}
